import { Backdrop, Box } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddIcon from "@material-ui/icons/Add";
import { useSimpleModalToggle } from "components/dialogs/useSimpleModal";
import { AddProductArticle } from "components/ProductArticles/AddProductArticle";
import React from "react";
import { FormWithRedirect, useRefresh, useTranslate } from "react-admin";
import { useMutateForm } from "api/useMutateForm";

import { AddEditOrderProductArticleFieldBody } from "./AddEditOrderProductArticleFieldBody";

export const AddOrderProductArticle = ({
	orderId,
	companyId,
	productArticleReloadKey,
	setProductArticleReloadKey,
	totalBoxes,
	allOrderProductArticles,
	disableAdd = false,
	...props
}) => {
	const refresh = useRefresh();
	const translate = useTranslate();

	const { open, handleOpen, handleClose } = useSimpleModalToggle();

	const [handleSubmit, { loading }] = useMutateForm(
		"create",
		"order-product-articles",
		null,
		null,
		{},
		() => { handleClose(); refresh(); return true; },
		(values) => ({ ...values, order_id: orderId }),
		translate("osfc.dialogs.order-product-articles.add.success")
	);

	return (
		<>
			<Button
				aria-label="create"
				size="small"
				color="primary"
				startIcon={<AddIcon />}
				onClick={handleOpen}
				disabled={disableAdd}
			>
				{translate("resources.order-product-articles.create-button")}
			</Button>
			{open && (
				<Dialog open={true} maxWidth="md" onClose={handleClose}>
					<DialogTitle>
						<Box display="flex" justifyContent="space-between" alignItems="center">
							<span>{translate("resources.order-product-articles.create.title")}</span>

							<AddProductArticle
								companyId={companyId}
								createButton={
									<Button size="small" variant="contained" color="primary" startIcon={<AddIcon />}>
										{translate("resources.product-articles.add-product-articles")}
									</Button>
								}
								isNeedRefresh={false}
								onCreated={() => setProductArticleReloadKey((prev) => prev + 1)}
							/>
						</Box>
					</DialogTitle>

					<Box position="relative">
						<FormWithRedirect
							record={{}}
							submitOnEnter={false}
							component={DialogContent}
							save={handleSubmit}
							render={({ handleSubmitWithRedirect, form, record }) => {
								return (
									<React.Fragment>
										<AddEditOrderProductArticleFieldBody
											form={form}
											companyId={companyId}
											productArticleReloadKey={productArticleReloadKey}
											totalBoxes={totalBoxes}
											allOrderProductArticles={allOrderProductArticles}
											isAddMode={true}
										/>
										<DialogActions>
											<Button disabled={loading} onClick={handleClose} color="primary">
												{translate("ra.action.cancel")}
											</Button>
											<Button disabled={loading} onClick={handleSubmitWithRedirect} color="primary">
												{translate("ra.action.add")}
											</Button>
										</DialogActions>
									</React.Fragment>
								);
							}}
						/>
						<Backdrop
							open={loading}
							style={{
								position: "absolute",
								zIndex: 1000,
								backgroundColor: "rgba(255, 255, 255, 0.7)",
							}}
						>
							<CircularProgress />
						</Backdrop>
					</Box>
				</Dialog>
			)}
		</>
	);
};
